
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography, Button, Container, Link, Checkbox } from '@mui/material';
import React, { useState } from 'react';
import { makeStyles } from "tss-react/mui";
import HTMLReactParser from 'html-react-parser';
import DisclaimerProps from '../../models/disclaimer-props.model';
// import Frame2 from "./../../assets/images/svg/frame-22.svg";

const DisclaimerPdf = require("../../assets/docs/Disclaimers.pdf");

const Disclaimer: React.FC<DisclaimerProps> = (props) => {
	const useStyles = makeStyles()((theme: any) => ({
		logo: {
			margin: theme.spacing(2),
			height: 70,
			width: 70,
		},
		closeButton: {
			color: `${theme.palette.primary.main} !important`,
			backgroundColor: `${theme.palette.secondary.main} !important`,
			padding: theme.spacing(1),
			fontSize: '1.0rem !important',
			cursor: 'pointer',
			'&:hover': {
				backgroundColor: `${theme.palette.primary.main} !important`,
				color: `${theme.palette.secondary.main} !important`,
			}
		},
		checkbox: {
			fontSize: '1.0rem !important',
			marginLeft: '-0.75rem !important',
			color: `black !important`,
			'&.Mui-checked': {
				color: `${theme.palette.secondary.main} !important`,
			},
		},
		supportDocumentList:
		{
			fontSize: '1.2rem !important',
			'& li': {
				marginBottom: theme.spacing(1),
				marginLeft: theme.spacing(-1),
			}
		}
	}));

	const { classes } = useStyles();
	const disclaimerValue = localStorage.getItem('dashboardDisclaimerOpened') === 'true';
	const userEnablement = localStorage.getItem('userEnablement') === 'true';
	const [isDisclaimerOpen, setIsDisclaimerOpen] = useState(!disclaimerValue);
	const [hideAlertMessage, setHideAlertMessage] = useState(true);

	const allCheckboxesChecked = () => {
		// filter checkboxes and return all except id has reive-info
		const checkboxes = document.querySelectorAll('input[type="checkbox"]:not(#checkbox-receive-info)');
		const checkedCheckboxes = document.querySelectorAll('input[type="checkbox"]:checked:not(#checkbox-receive-info)');
		return checkboxes.length === checkedCheckboxes.length;
	}

	const updateUserEnablement = (userAcceptEnabled: boolean) => {
		const accessToken = localStorage.getItem('accessToken');
		const microserviceConfig = {
			// url: 'https://wsro-dev.cremedatafoundry.com/enablement',
			url: 'https://wsro.cremedatafoundry.com/enablement',
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				"Authorization": `Bearer ${accessToken}`,
				'Accept': 'application/json',
				'Access-Control-Allow-Origin': '*',
				'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS',
				'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token',
				'Access-Control-Allow-Credentials': 'true',
			}
		};

		fetch(microserviceConfig.url, microserviceConfig)
			.then(response => response.json())
			.then(data => {
				localStorage.setItem('userEnablement', 'true');
				localStorage.setItem('dashboardDisclaimerOpened', JSON.stringify(true));
				setTimeout(() => {
					props.onClick(true);
					setIsDisclaimerOpen(false);
				}, 3000);


			})
			.catch(error => console.log(error));
	};
	const handleAccept = () => {
		if (allCheckboxesChecked()) {
			setHideAlertMessage(true);
			updateUserEnablement(true);

		} else {
			setHideAlertMessage(false);
		}
	};

	const handleClose = () => {
		setIsDisclaimerOpen(false);
	};
	const verifyCheckboxLabel = { inputProps: { 'aria-label': 'I have read and agree to the above terms and conditions.' } };

	return (

		<Container id="disclaimer-container"
		>
			<Dialog
				open={isDisclaimerOpen}
				onClose={handleClose}
				scroll={'body'}
				aria-labelledby="disclaimer-dialog-title"
				aria-describedby="disclaimer-dialog-description"
				style={{
					fontSize: '1.0rem !important',
				}}
			>
				<DialogContent>
					<DialogContentText id="disclaimer-dialog-description"
						style={{
							fontSize: '1.0rem !important',
						}}
						component={'div'}>
						<Typography>{props.data.data.disclaimerContent.welcomeText}</Typography>
						<ul>
							{props.data.data.disclaimerContent.content.map((item: any, index: any) => {
								return <li
									style={{
										fontSize: '1.0rem !important',
										marginBottom: '0.5rem !important',
									}}
									key={index}>{HTMLReactParser(item)}</li>
							})}
						</ul>
						<Typography
							style={{
								fontSize: '1.2rem !important',
							}}
						>
							{"To proceed, please tick to confirm that you:"}
						</Typography>
						<ul className={classes.supportDocumentList}
							style={{
								fontSize: '1.0rem !important',
							}}
						>
							{props.data.data.supportDocuments.map((supportDocument: any, index: any) => {
								return (
									<li key={index}
										style={{
											fontSize: '1.0rem !important',
											marginBottom: '0.5rem !important',
										}}
									>
										{supportDocument.isCheckbox ? <Checkbox
											// check if optionalId is empty or not 
											id={`checkbox-${supportDocument.optionalId ? supportDocument.optionalId : index
												}`}
											{...verifyCheckboxLabel} className={classes.checkbox} /> : ''}
										{HTMLReactParser(supportDocument.body)}
										{supportDocument.link && <Link color={'secondary'} target={"_blank"} href={supportDocument.link}>{supportDocument.text}</Link>}
									</li>)
							})}
						</ul>
						<ul>
							{props.data.data.otherDocuments.map((otherDocument: any, index: any) => {
								return (
									<li key={index}>{HTMLReactParser(otherDocument.body)}
										{otherDocument.link && <Link color={'secondary'} target={"_blank"} href={otherDocument.link}>{otherDocument.text}</Link>}
									</li>)
							})}
						</ul>
					</DialogContentText>
					<DialogContentText id="disclaimer-dialog-description"
						style={{
							fontSize: '1.0rem !important',
						}}
						component={'div'}>
						<Typography component={'span'} variant={'body2'}>
						</Typography>
					</DialogContentText>
					<Typography>
						<Checkbox
							id={'checkbox-accept'}
							className={classes.checkbox}
							{...verifyCheckboxLabel}

						/> {"I have read and agree to the above terms and conditions."}
					</Typography>
				</DialogContent>
				<DialogActions
					style={{
						fontSize: '1.0rem !important',
					}}
				>
					<p
						style={{
							color: 'red',
							fontSize: '1.0rem',
							margin: '0 auto',
						}}
						id={'alert-message'}
						hidden={hideAlertMessage}
					>{"Please read and tick all the checkboxes"}</p>
					<Button autoFocus onClick={handleAccept} className={classes.closeButton}>
						{props.data.data.disclaimerContent.buttonText}
					</Button>
				</DialogActions>
			</Dialog>
		</Container>
	);
}

export default Disclaimer;